import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthUser } from "./useAuth";
import { fetchUser } from "../services/userService";
import { authClient } from "../utils/authClient";

interface AuthContextValue {
  user:    AuthUser | null;
  loading: boolean;
  error:   string | null;
}

const AuthContext = createContext<AuthContextValue>({
  user:    null,
  loading: true,
  error:   null,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user,    setUser]    = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState<string | null>(null);

  useEffect(() => {
    authClient.tokenManager.getTokens()
      .then(({ idToken }: any) => {
        const email = String(idToken?.claims?.email ?? "").toLowerCase();
        return fetchUser(email);
      })
      .then(setUser)
      .catch((e: any) => setError(e.message ?? "Failed to load user."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext(): AuthContextValue {
  return useContext(AuthContext);
}
